import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
var _jsxFileName = "/home/christian/DEV/workspace/crossbuilders/form-library/src/lib/components/fields/Switch/index.jsx";
import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { inputDefaultProps, inputPropTypes } from '../../../commonProps';
import '../../../assets/scss/3_components/_form-switch.scss';
import FormHint from '../../structure/FormHint';
import FormRow from '../../structure/FormRow';
import Label from '../../structure/Label';
function SwitchComponent(props) {
  var id = props.id,
    name = props.name,
    inputRef = props.inputRef,
    checked = props.checked,
    disabled = props.disabled,
    readOnly = props.readOnly,
    required = props.required,
    _onChange = props.onChange,
    children = props.children,
    labelClass = props.labelClass,
    wrapperClass = props.wrapperClass,
    errorClass = props.errorClass,
    inputClass = props.inputClass,
    controlClass = props.controlClass,
    rowClass = props.rowClass,
    errors = props.errors,
    warning = props.warning,
    info = props.info;
  var hasErrors = errors && Object.hasOwnProperty.call(errors, name);
  var errorMessage = hasErrors ? errors[name].message : null;
  var wrapperClassName = hasErrors ? "".concat(wrapperClass, " ").concat(errorClass) : wrapperClass;
  return /*#__PURE__*/React.createElement(FormRow, {
    className: rowClass,
    hasErrors: hasErrors,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Label, {
    id: id,
    className: labelClass,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 13
    }
  }, children), /*#__PURE__*/React.createElement("div", {
    className: wrapperClassName,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("input", {
    ref: inputRef,
    type: "checkbox",
    id: id,
    name: name,
    className: inputClass,
    checked: checked,
    disabled: disabled,
    readOnly: readOnly,
    required: required,
    onChange: function onChange(event) {
      return _onChange(event.target.checked);
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: controlClass,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement(FormHint, {
    error: errorMessage,
    warning: warning,
    info: info,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 13
    }
  }));
}
export default function Switch(props) {
  var _this = this;
  return /*#__PURE__*/React.createElement(Controller, Object.assign({
    defaultValue: false
  }, props, {
    render: function render(_ref) {
      var onChange = _ref.onChange,
        onBlur = _ref.onBlur,
        value = _ref.value;
      return /*#__PURE__*/React.createElement(SwitchComponent, Object.assign({}, props, {
        onChange: onChange,
        onBlur: onBlur,
        checked: value === true,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 69,
          columnNumber: 13
        }
      }));
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 9
    }
  }));
}
Switch.propTypes = _objectSpread(_objectSpread({}, inputPropTypes), {}, {
  checked: PropTypes.bool,
  value: PropTypes.bool,
  wrapperClass: PropTypes.string,
  controlClass: PropTypes.string
});
Switch.defaultProps = _objectSpread(_objectSpread({}, inputDefaultProps), {}, {
  checked: false,
  value: false,
  labelClass: 'form-label form-label--checkbox',
  wrapperClass: 'form-switch',
  errorClass: 'form-switch--has-error',
  inputClass: 'form-switch__input',
  controlClass: 'form-switch__control'
});